import styled from 'styled-components';

export const Container = styled.div``;

export const NoticeStrip = styled.div`
	max-width: 1180px;
	margin: 0 auto;
	padding: 16px 16px 0;
	box-sizing: border-box;

	@media (min-width: 1441px) {
		max-width: 1330px;
	}
`;

export const Content = styled.div`
	width: 100%;
	max-width: 1180px;
	box-sizing: border-box;

	margin: 0 auto;

	padding: 54px 16px 12%;

	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 20px;

	@media (max-width: 767px) {
		align-items: center;
		flex-direction: column;
		padding: 54px 16px 12%;
	}

	@media (min-width: 768px) {
		padding: 54px 24px 12%;
		gap: 24px;
	}

	@media (min-width: 1441px) {
		max-width: 1330px;
	}
`;

export const NoticeBanner = styled.div<{
	$variant: "success" | "info" | "error";
}>`
	box-sizing: border-box;
	width: 100%;
	margin: 0 0 8px;
	padding: 14px 40px 14px 16px;
	border-radius: 10px;
	position: relative;
	font-size: 14px;
	line-height: 1.45;
	border: 1px solid
		${({ $variant }) =>
			$variant === "success"
				? "#c3e6cb"
				: $variant === "error"
					? "#f5c6cb"
					: "#b8d4f0"};
	background: ${({ $variant }) =>
		$variant === "success"
			? "#d4edda"
			: $variant === "error"
				? "#f8d7da"
				: "#e8f2fc"};
	color: ${({ $variant }) =>
		$variant === "success"
			? "#155724"
			: $variant === "error"
				? "#721c24"
				: "#1a4a6e"};

	@media (max-width: 767px) {
		padding-right: 36px;
	}
`;

export const NoticeClose = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 20px;
	line-height: 1;
	color: inherit;
	opacity: 0.65;
	padding: 4px;

	&:hover {
		opacity: 1;
	}
`;

export const InitialContainerToMobile = styled.div`
	display: none;

	@media(max-width: 767px){
		display: flex;
		align-items: center;
		justify-content: center;

		flex-direction: column;

		>h3{
			font-size: 17px;
			font-weight: 500;
			color: #B6B6B6;
		}

		>h1{
			font-size: 26px;
			font-weight: bold;

			margin: 12px 0 16px;
		}

		>img{
			width: 269px;
			height: 237px;

			margin-bottom: 32px;
		}
	}
`;


export const TitleAndImageContainer = styled.div`
	flex-shrink: 0;
	margin-top: 18px;
	margin-left: 0;
	max-width: 300px;

	display: flex;
	align-items: flex-start;
	justify-content: center;

	flex-direction: column;
	position: relative;
	z-index: 1;

	>h4{
		font-size: 12px;
		color: #B6B6B6;

		margin-bottom: 8px;
	}

	>h1{
		width: 90%;

		font-size: 29px;
		font-weight: bold;

		margin-bottom: 32px;
	}

	>img{
		width: 270px;
		height: 270px;
	}

	@media(max-width: 767px){
		display: none;
	}

	@media(min-width: 1441px){
		>h4{
			font-size: 13px;
		}

		>h1{
			font-size: 35px;
		}

		>img{
			width: 300px;
			height: 300px;
		}
	}
`;

export const PageWithTabsLayout = styled.div`
	flex: 1;
	min-width: 0;
	width: 100%;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	position: relative;
	z-index: 2;
	background: #fff;
`;

export const TabList = styled.div`
	display: flex;
	flex-direction: row;
	gap: 4px;
	margin-bottom: 20px;
	padding: 0 16px;
	box-sizing: border-box;
	border-bottom: 1px solid #e8e8e8;

	@media (min-width: 768px) {
		padding: 0;
		margin-bottom: 24px;
		gap: 8px;
	}
`;

export const TabButton = styled.button<{ $active: boolean }>`
	position: relative;
	padding: 14px 18px;
	margin-bottom: -1px;
	border: none;
	background: transparent;
	font-size: 15px;
	font-weight: 600;
	font-family: inherit;
	cursor: pointer;
	color: ${({ $active }) => ($active ? "#c94e28" : "#666")};
	border-bottom: 2px solid
		${({ $active }) => ($active ? "#DD6536" : "transparent")};
	transition: color 0.15s ease, border-color 0.15s ease;

	&:hover {
		color: ${({ $active }) => ($active ? "#c94e28" : "#333")};
	}

	&:focus-visible {
		outline: 2px solid #8eb9ff;
		outline-offset: 2px;
		border-radius: 4px;
	}
`;

export const TabPanel = styled.div<{ $visible: boolean }>`
	width: 100%;
	max-width: 100%;
	min-width: 0;
	min-height: 200px;
	box-sizing: border-box;
	padding: 0 16px;
	display: ${({ $visible }) => ($visible ? "block" : "none")};
	overflow-x: hidden;

	@media (min-width: 768px) {
		padding: 0;
	}
`;

export const AlertsSection = styled.section`
	width: 100%;
	margin: 0 0 20px;
	padding: 0;
	box-sizing: border-box;

	@media (min-width: 768px) {
		margin-bottom: 24px;
	}
`;

export const AlertsSectionTitle = styled.h2`
	margin: 0 0 6px 0;
	font-size: 22px;
	font-weight: 700;
	color: #2b2b2b;

	@media (max-width: 767px) {
		font-size: 20px;
	}
`;

export const AlertsSectionSubtitle = styled.p`
	margin: 0 0 16px 0;
	font-size: 14px;
	line-height: 1.45;
	color: #666;
`;

export const AlertsList = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const AlertCard = styled.li`
	border: 1px solid #e0e0e0;
	border-radius: 12px;
	padding: 16px 18px;
	background: #fafafa;
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
`;

export const AlertCardBody = styled.div`
	flex: 1;
	min-width: 200px;
`;

export const AlertCardTitle = styled.p`
	margin: 0 0 8px 0;
	font-size: 15px;
	font-weight: 600;
	color: #333;
`;

export const AlertCardMeta = styled.p`
	margin: 0;
	font-size: 13px;
	line-height: 1.5;
	color: #555;
`;

export const AlertCardActions = styled.div`
	flex-shrink: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
`;

export const AlertEditButton = styled.button`
	border: 1px solid #d0d0d0;
	background: #fff;
	color: #333;
	padding: 8px 14px;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;

	&:hover {
		background: #f5f5f5;
		border-color: #bbb;
	}
`;

export const AlertRemoveButton = styled.button`
	border: 1px solid #e0e0e0;
	background: #fff;
	color: #c62828;
	padding: 8px 14px;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;

	&:hover:not(:disabled) {
		background: #ffebee;
		border-color: #ffcdd2;
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

export const AlertsEmpty = styled.p`
	margin: 0;
	font-size: 14px;
	color: #888;
	font-style: italic;
`;

export const AlertsLoading = styled.p`
	margin: 0;
	font-size: 14px;
	color: #666;
`;